import { Services } from '@sigma-frontend-libs/commons'

import entity from '@/components/entity'
import filterBy from '@/components/services/report-manager/commons/filterBy/entity'
import timeline from '@/components/services/report-manager/commons/timeline'
import { serviceNameKebabCase } from '@/components/services/report-manager/recurrent/utils'

function renderEntity(h) {
  return h(
    entity,
    {
      props: {
        value: this.fields,
        service: Services['report-manager/recurrent'],
        fields: Object.keys(this.fields)
      }
    }
  )
}
function renderFilterBy(h) {
  return h(
    filterBy,
    {
      props: {
        value: this.value
      }
    }
  )
}

function renderHeader(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__header`
    },
    [
      renderEntity.call(this, h),
      renderFilterBy.call(this, h)
    ]
  )
}

function renderTimeline(h) {
  return h(
    timeline,
    {
      props: {
        value: this.value,
        service: Services['report-manager/recurrent']
      }
    }
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__body`
    },
    [ renderTimeline.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
